import JobOpeningList from "../../elements/job-opening-list/job-opening-list";
import { TJobOpeningListItem } from "../../../types/job-opening-types";
import SectionHead from "../../elements/section-head/section-head";
import styles from "./job-opening-list-block.module.less";
import { TLink } from "../../../types/link-types";
import { TIndexableBlock } from "../../../types/general-block-types";
import { m as motion } from "motion/react";
import { useAnimateFadeIn, useAnimateFadeInToTop } from "../../../animation/animation";
import { isOrHandleAsExternalUrl } from "../../../helpers";
import LinkWrapper from "../../elements/link-wrapper/link-wrapper";

export type TJobOpeningListBlockProps = {
  heading: string;
  text?: string;
  jobOpenings: Array<TJobOpeningListItem>;
  link?: TLink;
  fallbackText?: string;
  maxNumberOfJobOpenings?: number;
} & TIndexableBlock;

export const JobOpeningListBlock = ({
  heading,
  text,
  jobOpenings,
  link,
  fallbackText,
  maxNumberOfJobOpenings,
  index,
}: TJobOpeningListBlockProps) => {
  const fadeInAnimation = useAnimateFadeIn({ whileInView: true, easing: "easeInOut" }, { blockIndex: index });
  const fadeInToTopAnimation = useAnimateFadeInToTop({ whileInView: true, delay: 0.2, easing: "easeOut" });

  return (
    <section className={[styles.wrapper, "max-width padded-sides"].join(" ")}>
      <motion.div {...fadeInAnimation}>
        <SectionHead heading={heading} text={text} index={index} />
      </motion.div>
      <JobOpeningList
        jobOpenings={jobOpenings}
        maxNumberOfJobOpenings={maxNumberOfJobOpenings}
        fallbackText={fallbackText}
      />
      <motion.div {...fadeInToTopAnimation} className={styles.buttonWrapper}>
        {link && (
          <LinkWrapper
            url={link?.url}
            title={link?.title}
            target={isOrHandleAsExternalUrl(link.url, link.target) ? "_blank" : undefined}
            onPreNavigate={link.onPreNavigate}
          />
        )}
      </motion.div>
    </section>
  );
};

export default JobOpeningListBlock;
